module.exports = __webpack_public_path__ + "static/img/balloon.2080e7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/balloon.jpg
// module id = GG9W
// module chunks = 1